import React from "react";
import ReactDOM from "react-dom";
import "../../styles/components/modal-component.css";

const Modal = ({
  isOpen,
  onClose,
  children,
  zIndex = 1000,
  contentClassName = "",
  overlayClassName = "",
  style = {},
}) => {
  if (!isOpen) return null;

  const modalContent = (
    <div
      className={`modal-overlay ${overlayClassName}`.trim()}
      onClick={onClose}
      style={{ zIndex }}
    >
      <div
        className={`modal-content ${contentClassName}`.trim()}
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
        style={style}
      >
        <button
          onClick={onClose}
          className="modal-close-btn"
          aria-label="Close modal"
        >
          ×
        </button>
        {children}
      </div>
    </div>
  );

  // Use React Portal to render the modal at the document body level
  return ReactDOM.createPortal(modalContent, document.body);
};

export default Modal;
